<template>
    <div>
      <Card
        style="margin-top:20px"
        :loading="loading"
        :style="{
          backgroundImage: `url(${getWaterMarkStatus})`
        }"
      >
        <p slot="title">职业发展</p>
        <Form
          style="margin: 30px 20px"
          :model="formItem"
          :label-width="220"
          label-position="left"
          :disabled="modal_loading"
        >
          <div class="formRow">
            <div class="formCol" v-if="showSelfData.perresult == '1'">
              <FormItem
                :label="lang == 'zh' ? chNameMap.perresult : enNameMap.perresult"
              >
              <Select
                :clearable="true"
                v-model="formItem.perresult"
                :disabled="true"
              >
                <Option
                  v-for="item in optionData.YesOrNo"
                  :value="item.code"
                  :key="item.code"
                  :label="item.ch_value"
                ></Option>
              </Select>
              </FormItem>
            </div>
            <div class="formCol" v-if="showSelfData.hrgrade == '1'">
              <FormItem :label="lang == 'zh' ? chNameMap.hrgrade : enNameMap.hrgrade">
                <Input
                  v-model="formItem.hrgrade"
                  :disabled="true"
                />
              </FormItem>
            </div>
            <div class="formCol" v-if="showSelfData.hrmanage == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.hrmanage : enNameMap.hrmanage
                "
              >
                <Input
                  v-model="formItem.hrmanage"
                  :disabled="true"
                />
              </FormItem>
            </div>
            
            <div class="formCol" v-if="showSelfData.careerIdeal == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.careerIdeal : enNameMap.careerIdeal
                "
              >
                <Input
                  v-model="formItem.careerIdeal"
                  :disabled="plan ? true : false"
                />
              </FormItem>
            </div>
            <div class="formCol" v-if="showSelfData.crossRegion == '1'">
              <FormItem :label="lang == 'zh' ? chNameMap.crossRegion : enNameMap.crossRegion">
                <Select
                :clearable="true"
                v-model="formItem.crossRegion"
                :disabled="plan ? true : false"
              >
                <Option
                  v-for="item in optionData.CrossRegional"
                  :value="item.code"
                  :key="item.code"
                  :label="item.ch_value"
                ></Option>
              </Select>
              </FormItem>
            </div>
  
            <div class="formCol" v-if="showSelfData.crossFun == '1'">
              <FormItem
                :label="lang == 'zh' ? chNameMap.crossFun : enNameMap.crossFun"
              >
              <Select
                :clearable="true"
                v-model="formItem.crossFun"
                :disabled="plan ? true : false"
              >
                <Option
                  v-for="item in optionData.YesOrNo"
                  :value="item.code"
                  :key="item.code"
                  :label="item.ch_value"
                ></Option>
              </Select>
              </FormItem>
            </div>
            <div class="formCol" v-if="showSelfData.nextJob == '1'">
                <FormItem
                  :label="lang == 'zh' ? chNameMap.nextJob : enNameMap.nextJob"
                >
                  <Select
                  :clearable="true"
                  v-model="formItem.nextJob"
                  :disabled="plan ? false : true"
                >
                  <Option
                    v-for="item in optionData.NextJob"
                    :value="item.code"
                    :key="item.code"
                    :label="item.ch_value"
                  ></Option>
                </Select>
                </FormItem>
              </div>
              <div class="formCol" v-if="showSelfData.releaseDate == '1'">
                <FormItem
                  :label="lang == 'zh' ? chNameMap.releaseDate : enNameMap.releaseDate"
                >
                  <DatePicker
                    :disabled="plan ? false : true"
                    type="date"
                    v-model="formItem.releaseDate"
                    @on-change="dateChange"
                    style="width:100%"
                  ></DatePicker>
                </FormItem>
              </div>
            <div class="formCol" v-if="showSelfData.exitRisk == '1'">
              <FormItem :label="lang == 'zh' ? chNameMap.exitRisk : enNameMap.exitRisk">
               
                <Select
                  :clearable="true"
                  v-model="formItem.exitRisk"
                  :disabled="plan ? false : true"
                >
                  <Option
                    v-for="item in optionData.ExitRisk"
                    :value="item.code"
                    :key="item.code"
                    :label="item.ch_value"
                  ></Option>
                </Select>
              </FormItem>
            </div>
            <div class="formCol" v-if="showSelfData.exitAffect == '1'">
              <FormItem :label="lang == 'zh' ? chNameMap.exitAffect : enNameMap.exitAffect">
                <Input
                  v-model="formItem.exitAffect"
                  :disabled="plan ? false : true"
                />
              </FormItem>
            </div>
            
          </div>
        </Form>
      </Card>
      <div class="bottomBtn">
        <Button type="primary" :disabled="isClick"  @click="saveData()">保存</Button>
        <Button v-if="plan" @click="returnPage()" style="margin-left:15px"
          >返回</Button
        >
      </div>
      <Spin size="large" fix v-if="loading"> </Spin>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import watermark from "@/util/watermark";
  import DateUtil from "@/util/DateUtil";
  
  export default {
    props: ["componentMsg"],
    data() {
      return {
        date: new DateUtil(),
        loading: false,
        modal_loading: false,
        formItem: {
        },
        optionData: {},
        emp_code: 2,
        yesOrNo :[],
        crossRegional:[],
        oldFormItem: {},
        showSelfData: {},
        disableSelfData: {},
        plan: "",
        id: "",
        chNameMap: {},
        enNameMap: {},
        userId: "",
        action: "/api/BasicInformation/uploadUserPortrait",
        domCheck: true
      };
    },
    watch: {
      componentMsg(val) {
        console.log(val);
      }
    },
    computed: {
      //国际化监听
      lang() {
        return this.$store.getters.selectLangeData;
      },
      getWaterMarkStatus() {
        return this.$store.getters.getWaterMarkStatus == 1
          ? watermark.addWaterMark()
          : "";
      },
      isClick() {
        return JSON.stringify(this.getNewValue()) == "{}" 
      }
    },
    mounted() {
      
    },
    created() {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userId = userInfo.serialnumber;
    },
    methods: {
      dateChange() {},
      getNewValue() {
        let obj = {};
        for (var item in this.formItem) {
          if (this.oldFormItem[item] != this.formItem[item]) {
            if (this.formItem[item] instanceof Date) {
                this.formItem[item] = this.date.dateVal(this.formItem[item], "YYYY-MM-DD")
            }
            if (typeof this.oldFormItem[item] == "object") {
              if (
                this.oldFormItem[item].join("") != this.formItem[item].join("")
              ) {
                console.log(item, "typeof(this.oldFormItem[item])");
                obj[item] = this.formItem[item];
              }
            } else {
              obj[item] = this.formItem[item];
            }
          }
        }
        return obj;
      },
      saveData() {
        let newFormItem = this.getNewValue();
        this.$Modal.confirm({
          title: this.$notice("sureSave"),
          content: "",
          onOk: () => {
            let obj = {
              serialnumber: this.plan ? this.plan : this.userId,
              ...newFormItem
            };
            this.modal_loading = true;
            axios
              .post("/careerDevelopment/updateUserCareerDevelopmentData", obj)
              .then(res => {
                this.modal_loading = false;
                if (res) {
                  this.$Message.info(res);
                  this.getTableData();
                }
              });
          },
          onCancel: () => {}
        });
        this.$emit("getState", true);
      },
      getData(id, plan) {
        this.plan = plan ? plan : "";
        this.id = id;
        this.getTableData();
      },
      getTableData() {
        let obj = {
          sheetId: this.id,
          serialnumber: this.plan ? this.plan : this.userId,
          bePersonal: this.plan ? "0" : "1",
          sheetType:this.plan ? "1" : "0"
        };
        this.loading = true;
        axios
          .post("/careerDevelopment/selectUserCareerDevelopmentData", obj)
          .then(res => {
            if (res) {
              this.formItem = res.data.length > 0 ? res.data[0] : {};
              this.formItem.perresult == 'Y' ? this.formItem.perresult = "1" : this.formItem.perresult="0";
              console.log(this.formItem)
              for (var item in this.formItem) {
                 if (typeof(this.formItem[item]) == 'string'  && this.formItem[item].indexOf('1900-01-01') != -1) {
                  this.formItem[item] = ''
                 }
              }
              this.optionData = res.optionData;
              this.oldFormItem = JSON.parse(JSON.stringify(this.formItem));
              this.showSelfData = res.showSelfData;
              this.disableSelfData = res.disableSelfData;
              this.chNameMap = res.chNameMap;
              this.enNameMap = res.enNameMap;
            }
            this.loading = false;
          });
      },
      returnPage() {
        this.$router.back();
      },
      domClick() {
        this.domCheck = false;
        this.$nextTick(() => {
          this.domCheck = true;
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .photoava {
    float: right;
    margin-top: -160px;
    margin-right: 4%;
    height: 200px;
    width: 100px;
    top: 160px;
    right: 0;
    position: absolute;
    img {
      height: 130px;
      width: 100px;
      border: #084d92 1px solid;
    }
    span {
      height: 130px;
      width: 100px;
      border: #084d92 1px solid;
      text-align: center;
      line-height: 130px;
      -webkit-writing-mode: vertical-rl;
      writing-mode: vertical-rl;
    }
    div {
      display: flex;
      justify-content: center;
    }
  }
  .formRow {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }
  .formCol {
    width: calc((100% - 202px - 4%) / 3);
    float: left;
    margin-right: 30px;
  }
  
  @media screen and (max-width: 1100px) {
    .formCol {
      width: 45%;
      margin-right: 2%;
    }
    .photoava {
      top: 0;
      margin-top: 0px;
      position: relative;
    }
  }
  @media screen and (max-width: 770px) {
    .formCol {
      width: 100%;
      margin-right: 0px;
    }
    .photoava {
      top: 0;
      margin-top: 0px;
      position: relative;
    }
  }
  .bottomBtn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  .ivu-date-picker {
    width: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/process/MyQuery/components/CareerDevelopment.vue